import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "ma-0" };
const _hoisted_2 = { class: "td__order-count" };
const _hoisted_3 = { class: "td__supply-value" };
const _hoisted_4 = { class: "td__vat" };
const _hoisted_5 = { class: "td__total-amount" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_BarogoTooltip = _resolveComponent("BarogoTooltip");
    const _component_Chip = _resolveComponent("Chip");
    return (_openBlock(), _createElementBlock("tr", null, [
        _createElementVNode("td", null, [
            (_ctx.tooltipText)
                ? (_openBlock(), _createBlock(_component_BarogoTooltip, { key: 0 }, {
                    activatorSlot: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t(`${_ctx.lc}${_ctx.itemName}`)), 1 /* TEXT */)
                    ]),
                    tooltipMessage: _withCtx(() => [
                        _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.tooltipText), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                }))
                : (_openBlock(), _createElementBlock("span", {
                    key: 1,
                    class: _normalizeClass(_ctx.itemNameClass),
                    onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.handleClickReportItemName()))
                }, _toDisplayString(_ctx.$t(`${_ctx.lc}${_ctx.itemName}`)), 3 /* TEXT, CLASS */)),
            (_ctx.chipInfo)
                ? (_openBlock(), _createBlock(_component_Chip, {
                    key: 2,
                    "brg-chip-color": _ctx.chipInfo.color,
                    text: _ctx.chipInfo.text
                }, null, 8 /* PROPS */, ["brg-chip-color", "text"]))
                : _createCommentVNode("v-if", true)
        ]),
        _createElementVNode("td", _hoisted_2, _toDisplayString(_ctx.orderCount), 1 /* TEXT */),
        _createElementVNode("td", _hoisted_3, _toDisplayString(_ctx.supplyValue), 1 /* TEXT */),
        _createElementVNode("td", _hoisted_4, _toDisplayString(_ctx.VATAmount), 1 /* TEXT */),
        _createElementVNode("td", _hoisted_5, _toDisplayString(_ctx.totalAmount), 1 /* TEXT */)
    ]));
}
